import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { Parametro } from 'src/app/intranet/model/parametro';

@Component({
    selector: 'sura-estado-dialog',
    templateUrl: './estado-dialog.component.html',
    styleUrls: ['./estado-dialog.component.scss']
  })
export class EstadoDialogComponent implements OnInit {

    form: UntypedFormGroup;
    estadoActual: string;
    listaEstados: Parametro[] = [];

    constructor(
        private fb: UntypedFormBuilder,
        private dialogRef: MatDialogRef<EstadoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) estadoActual: string ) {
        this.estadoActual = estadoActual;
        this.form = fb.group({
          nuevoEstado: ['']
        });
    }

    ngOnInit() {
      this.obtenerSiguientesEstados(this.estadoActual);
    }

    obtenerSiguientesEstados(estado: string) {
      switch (estado) {
        case 'P':
          this.agregarParametro('V', 'Validada');
          this.agregarParametro('X', 'Cancelada');
          break;
        case 'V':
          this.agregarParametro('I', 'Iniciada');
          break;
        case 'I':
          this.agregarParametro('R', 'Registro Pausado');
          this.agregarParametro('S', 'Votación Pausada');
          this.agregarParametro('F', 'Finalizada');
          break;
        case 'R':
          this.agregarParametro('I', 'Iniciada');
          this.agregarParametro('S', 'Votación Pausada');
          this.agregarParametro('F', 'Finalizada');
          break;
        case 'S':
          this.agregarParametro('I', 'Iniciada');
          this.agregarParametro('R', 'Registro Pausado');
          this.agregarParametro('F', 'Finalizada');
          break;
        default:
          this.dialogRef.close();
          break;
      }
    }

    agregarParametro(codigo: string, descripcion: string) {
      const parametro = new Parametro();
      parametro.codigo = codigo;
      parametro.descripcion = descripcion;
      this.listaEstados.push(parametro);
    }

    save() {
        this.dialogRef.close(this.form.value);
    }

    close() {
        this.dialogRef.close();
    }

}
